import { api } from "@/common/http/axios";
import type { BindingVo } from "@/apis/auth";

export interface MyBindings {
  local: BindingVo;
  feishu: BindingVo;
}

/** 个人中心专用：仅返回绑定信息（轻量，不带角色 / 权限）。 */
export const fetchMyBindings = async (): Promise<MyBindings | null> => {
  try {
    const res = await api.get("/me/bindings");
    return (res.data?.data as MyBindings) ?? null;
  } catch {
    return null;
  }
};

/** 自助解绑飞书；后端要求至少保留一种登录方式，否则返回 400。 */
export const myUnbindFeishu = async (): Promise<boolean> => {
  const res = await api.post("/me/unbind-feishu");
  return res.data?.code === 0;
};
